<template>
  <d-modal v-if="showModal" @close="handleClose">
    <d-modal-header>
      <d-modal-title>{{ title }}</d-modal-title>
    </d-modal-header>
    <d-modal-body>{{ message }}</d-modal-body>
  </d-modal>
</template>

<script>
export default {
  props: {
    showModal: { type: Boolean, default: false },
    title: { type: String, default: "" },
    message: { type: String, default: "" }
  },
  methods: {
    handleClose() {
      this.$emit("modalClose", false);
    }
  }
};
</script>
